import './leaderboard-my-rank.scss';

import { useTranslation } from 'react-i18next';

import type { LeaderboardEntry, LeaderboardSortBy } from '@/entities/leaderboard';
import CupIcon from '@/shared/assets/icons/cup.svg?react';
import TonIcon from '@/shared/assets/icons/ton.svg?react';
import { PlayerAvatar } from '@/shared/ui/PlayerAvatar';

const formatMetric = (sortBy: LeaderboardSortBy, entry: LeaderboardEntry): string => {
  if (sortBy === 'games') return String(entry.totalGames);
  const value = sortBy === 'profit' ? entry.maxWin : entry.totalWagered;
  if (Math.abs(value) >= 100) return value.toFixed(1);
  return value.toFixed(2);
};

type LeaderboardMyRankProps = {
  rank: number;
  entry: LeaderboardEntry;
  sortBy: LeaderboardSortBy;
};

export function LeaderboardMyRank({ rank, entry, sortBy }: LeaderboardMyRankProps) {
  const { t } = useTranslation();

  return (
    <div className="leaderboard-my-rank">
      <div className="leaderboard-my-rank__rank">
        {rank <= 3 ? (
          <div className={`leaderboard-my-rank__badge leaderboard-my-rank__badge--${rank === 1 ? 'gold' : rank === 2 ? 'silver' : 'bronze'}`}>
            <CupIcon className="leaderboard-my-rank__trophy" />
          </div>
        ) : (
          <span className="leaderboard-my-rank__rank-num">#{rank}</span>
        )}
      </div>
      <PlayerAvatar id={entry.userId} avatar={entry.avatar} size={30} />
      <div className="leaderboard-my-rank__info">
        <span className="leaderboard-my-rank__username">{entry.username ?? t('leaderboard.you')}</span>
        <span className="leaderboard-my-rank__meta">
          {entry.totalGames} {t('leaderboard.games')}
          {entry.winsCount > 0 && ` · ${entry.winsCount} ${t('leaderboard.wins')}`}
        </span>
      </div>
      <span className={`leaderboard-my-rank__metric leaderboard-my-rank__metric--${sortBy}`}>
        {sortBy !== 'games' && <TonIcon className="leaderboard-my-rank__metric-icon" />}
        {formatMetric(sortBy, entry)}
      </span>
    </div>
  );
}
